// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"f385145c","242":"951f9bf2","306":"4fdc5bc8","453":"fe3134fd"}[chunkId] + ".chunk.js";
};